<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Starting Float</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>

      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-btn color="primary" small to="/new-starting-float">
              <v-icon left dark>mdi-plus</v-icon>New Float
            </v-btn>
          </v-col>

          <v-col cols="12">
            <v-data-table
              :loading="loading"
              loading-text="Loading... Please wait"
              :headers="headers"
              :items="floatsData"
              :search="search"
            >
              <template v-slot:[`item.amount`]="{ item }">
                <span>{{ item.amount | currency }}</span>
              </template>
              <template v-slot:[`item.doc_date`]="{ item }">
                <span>{{ item.doc_date  | date}}</span>
              </template>
              <template v-slot:[`item.action`]="{ item }">
                <v-btn color="editIcon" text :to="`/starting-float/${item.id}`" icon>
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    search: "",
    loading: false,
    editItem: {},
    loader: false,
    editDialog: false,
    floatsData: [],
    headers: [
      { text: "Starting Float", value: "amount" },
      { text: "Date", value: "doc_date" },
      { text: "Action", value: "action" },
    ]
  }),
  methods: {
    getFloats() {
      const self = this;
      this.loading = true;
      this.$store
        .dispatch("get", `/starting-floats`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.floatsData = res.ResponseData;
            self.loading = false;
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    }
  },
  created() {
    this.getFloats();
  }
};
</script>
